<div class="ki-verbindung" data-testid="ki-verbindung-card">
  @switch (ladestatus()) {
    @case ('laedt') {
      <p class="ki-verbindung__hinweis" role="status" aria-live="polite" data-testid="ki-verbindung-laedt">
        {{ 'ki.verbindung.laedt' | translate }}
      </p>
    }
    @case ('fehler') {
      <p class="ki-verbindung__fehler" role="alert" data-testid="ki-verbindung-ladefehler">
        {{ 'ki.verbindung.ladefehler' | translate }}
      </p>
    }
    @default {
      @let regionParameter = { region: ('ki.verbindung.regionTyp.' + regionImFehler() | translate) };
      <div class="ki-verbindung__kopf">
        <app-ki-mark [size]="36" />
        <div class="ki-verbindung__kopf-text">
          <div class="ki-verbindung__titel" data-testid="ki-verbindung-titel">
            {{
              'ki.verbindung.titel'
                | translate: { zustand: ('ki.verbindung.zustand.' + zustand() + '.titel' | translate) }
            }}
          </div>
          <div class="ki-verbindung__zustandstext" data-testid="ki-verbindung-zustandstext">
            {{ 'ki.verbindung.zustand.' + zustand() + '.text' | translate }}
          </div>
        </div>
        <button
          type="button"
          role="switch"
          class="ki-schalter"
          data-testid="ki-verbindung-schalter"
          [class.ki-schalter--an]="projektAn()"
          [attr.aria-checked]="projektAn()"
          [attr.aria-label]="'ki.verbindung.schalter' | translate"
          [disabled]="gesperrt() || nurLesen()"
          (click)="projektUmschalten()"
        >
          <span class="ki-schalter__knopf"></span>
        </button>
      </div>

      @if (speicherFehlerKey(); as fehlerKey) {
        <div class="ki-verbindung__fehler" role="alert" data-testid="ki-verbindung-speicherfehler">
          {{ fehlerKey | translate: regionParameter }}
        </div>
      }

      @if (aufbewahrungUeberMaximum()) {
        <div class="ki-verbindung__fehler" role="alert" data-testid="ki-verbindung-aufbewahrung-hinweis">
          {{ 'ki.verbindung.aufbewahrungUeberMaximumHinweis' | translate: { max: maxAufbewahrungTage() } }}
        </div>
      }

      @if (projektAn()) {
        <div class="ki-verbindung__koerper" data-testid="ki-verbindung-koerper">
          <div class="ki-verbindung__arten" role="radiogroup" [attr.aria-label]="'ki.verbindung.art.label' | translate">
            <button
              type="button"
              role="radio"
              class="ki-verbindung__art ki-verbindung__art--gewaehlt"
              aria-checked="true"
              tabindex="0"
              data-testid="ki-verbindung-art-eigen"
              [disabled]="nurLesen()"
            >
              <span class="ki-verbindung__art-titel">{{ 'ki.verbindung.art.eigen' | translate }}</span>
              <span class="ki-verbindung__art-text">{{ 'ki.verbindung.art.eigenText' | translate }}</span>
            </button>
            <button
              type="button"
              role="radio"
              class="ki-verbindung__art"
              aria-checked="false"
              tabindex="-1"
              data-testid="ki-verbindung-art-spirit"
              disabled
            >
              <span class="ki-verbindung__art-titel">{{ 'ki.verbindung.art.spirit' | translate }}</span>
              <span class="ki-verbindung__art-text">{{ 'ki.verbindung.art.spiritText' | translate }}</span>
            </button>
          </div>

          <div class="ki-verbindung__raster">
            <label class="ki-verbindung__feld">
              <span class="ki-verbindung__label">{{ 'ki.verbindung.anbieter' | translate }}</span>
              <select
                #anbieterAuswahl
                class="ki-verbindung__eingabe"
                data-testid="ki-verbindung-anbieter"
                [disabled]="nurLesen()"
                (change)="anbieterWaehlen(anbieterAuswahl.value)"
              >
                <option value="" [selected]="!entwurf().anbieter">
                  {{ 'ki.verbindung.anbieterWaehlen' | translate }}
                </option>
                @for (anbieter of anbieterListe; track anbieter.typ) {
                  <option
                    [value]="anbieter.typ"
                    [disabled]="!istErlaubt(anbieter.typ)"
                    [selected]="entwurf().anbieter === anbieter.typ"
                  >
                    {{
                      ('ki.verbindung.anbieterTyp.' + anbieter.typ | translate) +
                        (istErlaubt(anbieter.typ) ? '' : ' ' + ('ki.verbindung.nichtFreigegeben' | translate))
                    }}
                  </option>
                }
              </select>
            </label>

            <div class="ki-verbindung__feld">
              <span class="ki-verbindung__label">{{ 'ki.verbindung.region' | translate }}</span>
              <div
                class="ki-verbindung__eingabe ki-verbindung__eingabe--lesend"
                data-testid="ki-verbindung-region"
                [class.ki-verbindung__region--drittland]="region() === 'DRITTLAND'"
              >
                {{ region() ? ('ki.verbindung.regionTyp.' + region() | translate) : '—' }}
              </div>
            </div>

            <label class="ki-verbindung__feld ki-verbindung__feld--breit">
              <span class="ki-verbindung__label">{{ 'ki.verbindung.endpunkt' | translate }}</span>
              <input
                #endpunktFeld
                type="url"
                class="ki-verbindung__eingabe ki-verbindung__eingabe--mono"
                data-testid="ki-verbindung-endpunkt"
                [class.ki-verbindung__eingabe--lesend]="!!festerEndpunkt()"
                [value]="festerEndpunkt() ?? entwurf().endpunkt"
                [readOnly]="!!festerEndpunkt()"
                [required]="endpunktPflicht()"
                [disabled]="nurLesen()"
                [attr.maxlength]="endpunktMax"
                (input)="endpunktAendern(endpunktFeld.value)"
              />
            </label>

            <div class="ki-verbindung__feld">
              <span class="ki-verbindung__label" id="ki-verbindung-token-label" data-testid="ki-verbindung-token-label">
                {{ 'ki.verbindung.token' | translate }}
                @if (tokenOptional()) {
                  {{ 'ki.verbindung.tokenOptional' | translate }}
                }
              </span>
              @if (tokenFeldSichtbar()) {
                <input
                  #tokenFeld
                  type="password"
                  class="ki-verbindung__eingabe"
                  data-testid="ki-verbindung-token"
                  autocomplete="new-password"
                  aria-labelledby="ki-verbindung-token-label"
                  [placeholder]="'ki.verbindung.tokenPlaceholder' | translate"
                  [value]="entwurf().apiToken"
                  [required]="tokenPflicht()"
                  [disabled]="nurLesen()"
                  [attr.maxlength]="tokenMax"
                  (input)="tokenAendern(tokenFeld.value)"
                />
              } @else {
                <div
                  class="ki-verbindung__eingabe ki-verbindung__eingabe--lesend ki-verbindung__token"
                  data-testid="ki-verbindung-token-gespeichert"
                >
                  <span class="ki-verbindung__token-text">
                    {{
                      'ki.verbindung.tokenGespeichert' | translate: { datum: tokenGespeichertAm() | date: 'dd.MM.yyyy' }
                    }}
                  </span>
                  <button
                    type="button"
                    class="ki-verbindung__link"
                    data-testid="ki-verbindung-token-ersetzen"
                    [disabled]="nurLesen()"
                    (click)="tokenErsetzen.set(true)"
                  >
                    {{ 'ki.verbindung.tokenErsetzen' | translate }}
                  </button>
                </div>
              }
            </div>

            <label class="ki-verbindung__feld">
              <span class="ki-verbindung__label">{{ 'ki.verbindung.modell' | translate }}</span>
              <input
                #modellFeld
                type="text"
                class="ki-verbindung__eingabe ki-verbindung__eingabe--mono"
                data-testid="ki-verbindung-modell"
                [value]="entwurf().modell"
                [required]="!!anbieterMeta()"
                [disabled]="nurLesen()"
                [attr.maxlength]="modellMax"
                (input)="modellAendern(modellFeld.value)"
              />
            </label>
          </div>

          <div class="ki-verbindung__erweitert">
            <button
              type="button"
              class="ki-verbindung__aufklapper"
              data-testid="ki-verbindung-erweitert"
              [attr.aria-expanded]="erweitertOffen()"
              (click)="erweitertOffen.set(!erweitertOffen())"
            >
              <mat-icon
                class="ki-verbindung__chevron"
                [class.ki-verbindung__chevron--offen]="erweitertOffen()"
                aria-hidden="true"
              >
                chevron_right
              </mat-icon>
              {{ 'ki.verbindung.erweitert' | translate }}
            </button>
            @if (erweitertOffen()) {
              <div class="ki-verbindung__raster ki-verbindung__raster--erweitert">
                <label class="ki-verbindung__feld">
                  <span class="ki-verbindung__label">{{ 'ki.verbindung.kontextfenster' | translate }}</span>
                  <input
                    #kontextFeld
                    type="number"
                    inputmode="numeric"
                    min="1"
                    class="ki-verbindung__eingabe"
                    data-testid="ki-verbindung-kontextfenster"
                    [attr.max]="kontextfensterMax"
                    [value]="entwurf().kontextfenster ?? ''"
                    [disabled]="nurLesen()"
                    (input)="kontextfensterAendern(kontextFeld.value)"
                  />
                </label>
                <div class="ki-verbindung__feld">
                  <span class="ki-verbindung__label" id="ki-verbindung-tool-calling-label">
                    {{ 'ki.verbindung.toolCalling' | translate }}
                  </span>
                  <div class="ki-verbindung__schalter-zeile">
                    <button
                      type="button"
                      role="switch"
                      class="ki-schalter"
                      data-testid="ki-verbindung-tool-calling"
                      aria-labelledby="ki-verbindung-tool-calling-label"
                      [class.ki-schalter--an]="entwurf().toolCalling"
                      [attr.aria-checked]="entwurf().toolCalling"
                      [disabled]="nurLesen()"
                      (click)="toolCallingUmschalten()"
                    >
                      <span class="ki-schalter__knopf"></span>
                    </button>
                  </div>
                </div>
              </div>
            }
          </div>

          <div class="ki-verbindung__test">
            <div class="ki-verbindung__test-zeile">
              <button
                mat-stroked-button
                type="button"
                class="ki-verbindung__testen"
                data-testid="ki-verbindung-testen"
                [disabled]="!testMoeglich()"
                [disabledInteractive]="!nurLesen()"
                [attr.aria-describedby]="vorabFehlerKey() ? 'ki-verbindung-vorab' : null"
                (click)="testen()"
              >
                {{ (testLaeuft() ? 'ki.verbindung.test.laeuft' : 'ki.verbindung.test.starten') | translate }}
              </button>
              <span class="sr-only" role="status" aria-live="polite" data-testid="ki-verbindung-test-status">
                @if (testLaeuft()) {
                  {{ 'ki.verbindung.test.laeuft' | translate }}
                }
              </span>
              @if (test(); as stand) {
                @switch (stand.status) {
                  @case ('ok') {
                    <span
                      class="ki-verbindung__ergebnis ki-verbindung__ergebnis--ok"
                      role="status"
                      aria-live="polite"
                      data-testid="ki-verbindung-ergebnis"
                    >
                      <mat-icon class="ki-verbindung__ergebnis-icon" aria-hidden="true" fontIcon="check" />
                      {{ 'ki.verbindung.test.ok' | translate: { modell: stand.modell, ms: stand.dauerMs } }}
                    </span>
                  }
                  @case ('fehler') {
                    <span
                      class="ki-verbindung__ergebnis ki-verbindung__ergebnis--fehler"
                      role="alert"
                      data-testid="ki-verbindung-ergebnis"
                    >
                      <mat-icon class="ki-verbindung__ergebnis-icon" aria-hidden="true" fontIcon="close" />
                      {{ stand.key ? (stand.key | translate: regionParameter) : stand.text }}
                    </span>
                  }
                }
              } @else if (gespeichertGueltig()) {
                <span
                  class="ki-verbindung__ergebnis ki-verbindung__ergebnis--ok"
                  role="status"
                  aria-live="polite"
                  data-testid="ki-verbindung-ergebnis"
                >
                  <mat-icon class="ki-verbindung__ergebnis-icon" aria-hidden="true" fontIcon="check" />
                  @if (getestetAm(); as am) {
                    {{ 'ki.verbindung.test.geprueftAm' | translate: { datum: am | date: 'dd.MM.yyyy' } }}
                  } @else {
                    {{ 'ki.verbindung.test.gueltig' | translate }}
                  }
                </span>
              }
              @if (vorabFehlerKey(); as vorabKey) {
                <span class="ki-verbindung__vorab" id="ki-verbindung-vorab" data-testid="ki-verbindung-vorab">
                  {{ vorabKey | translate: regionParameter }}
                </span>
              }
            </div>
            @if (erneutTesten()) {
              <p class="ki-verbindung__erneut" data-testid="ki-verbindung-erneut-testen">
                {{ 'ki.verbindung.test.erneutTesten' | translate }}
              </p>
            }
          </div>

          <div class="ki-verbindung__funktionen">
            <div class="ki-verbindung__label">{{ 'ki.verbindung.funktionen' | translate }}</div>
            @for (funktion of funktionsListe; track funktion) {
              <div class="ki-verbindung__funktion">
                <div class="ki-verbindung__funktion-info">
                  <div
                    class="ki-verbindung__funktion-titel"
                    [class.ki-verbindung__funktion-titel--gesperrt]="!funktionErlaubt(funktion)"
                  >
                    {{ 'ki.verbindung.funktion.' + funktion | translate }}
                  </div>
                  <div
                    class="ki-verbindung__funktion-text"
                    [attr.data-testid]="'ki-verbindung-funktion-' + funktion + '-text'"
                  >
                    {{
                      (funktionErlaubt(funktion)
                        ? 'ki.verbindung.funktion.' + funktion + 'Text'
                        : 'ki.verbindung.funktionNichtFreigegeben'
                      ) | translate
                    }}
                  </div>
                </div>
                <button
                  type="button"
                  role="switch"
                  class="ki-schalter"
                  [attr.data-testid]="'ki-verbindung-funktion-' + funktion"
                  [class.ki-schalter--an]="funktionErlaubt(funktion) && entwurf().funktionen[funktion]"
                  [attr.aria-checked]="funktionErlaubt(funktion) && entwurf().funktionen[funktion]"
                  [attr.aria-label]="'ki.verbindung.funktion.' + funktion | translate"
                  [disabled]="!funktionErlaubt(funktion) || nurLesen()"
                  (click)="funktionUmschalten(funktion)"
                >
                  <span class="ki-schalter__knopf"></span>
                </button>
              </div>
            }
          </div>

          <div class="ki-verbindung__fuss">
            <ng-container [ngTemplateOutlet]="aufbewahrungFeld" />
            @if (verbrauch(); as v) {
              @let verbraucht =
                v.verbraucht.mio
                  ? ('ki.verbindung.verbrauch.mio' | translate: { wert: v.verbraucht.wert })
                  : v.verbraucht.wert;
              <div class="ki-verbindung__verbrauch">
                <div class="ki-verbindung__verbrauch-kopf">
                  <span class="ki-verbindung__verbrauch-label" data-testid="ki-verbindung-verbrauch-label">
                    {{ 'ki.verbindung.verbrauch.label' | translate }}
                  </span>
                  <span class="ki-verbindung__verbrauch-text" data-testid="ki-verbindung-verbrauch">
                    @if (v.kontingent; as kontingent) {
                      {{
                        'ki.verbindung.verbrauch.vonKontingent'
                          | translate
                            : {
                                verbraucht: verbraucht,
                                kontingent: kontingent.mio
                                  ? ('ki.verbindung.verbrauch.mio' | translate: { wert: kontingent.wert })
                                  : kontingent.wert,
                              }
                      }}
                    } @else {
                      {{ 'ki.verbindung.verbrauch.ohneKontingent' | translate: { verbraucht: verbraucht } }}
                    }
                  </span>
                </div>
                @if (v.kontingent) {
                  <div
                    class="ki-verbindung__verbrauch-balken"
                    data-testid="ki-verbindung-verbrauch-balken"
                    aria-hidden="true"
                  >
                    <div class="ki-verbindung__verbrauch-fuellung" [style.width.%]="v.prozent"></div>
                  </div>
                }
              </div>
            }
          </div>
        </div>
      } @else if (aufbewahrungUeberMaximum()) {
        <div class="ki-verbindung__raster ki-verbindung__aufbewahrung-ohne-ki">
          <ng-container [ngTemplateOutlet]="aufbewahrungFeld" />
        </div>
      }
    }
  }
</div>

<ng-template #aufbewahrungFeld>
  <label class="ki-verbindung__feld">
    <span class="ki-verbindung__label">{{ 'ki.verbindung.aufbewahrung' | translate }}</span>
    <select
      #aufbewahrungAuswahl
      class="ki-verbindung__eingabe"
      data-testid="ki-verbindung-aufbewahrung"
      [disabled]="nurLesen()"
      (change)="aufbewahrungWaehlen(aufbewahrungAuswahl.value)"
    >
      @for (option of aufbewahrungOptionen(); track option.tage) {
        <option [value]="option.tage" [selected]="entwurf().aufbewahrungTage === option.tage">
          {{ option.labelKey | translate: { tage: option.tage } }}
        </option>
      }
    </select>
  </label>
</ng-template>
